import 'fullpage.js/vendors/scrolloverflow';
import fullpage from 'fullpage.js';

document.addEventListener('DOMContentLoaded', () => {
  new fullpage('#fullpage', {
    scrollOverflow: true,
    // scrollOverflowReset: true,
    // responsiveWidth: 767,
    navigation: true,
    verticalCentered: false,
    anchors: ['section-1', 'section-2', 'section-3'],
    // licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE'
  });
});